import ExperimentKey from "../../Experiment/types/ExperimentKey";
import { IFlow } from "./IFlow";
import BaseExperimentalFlowResolver from "./BaseExperimentalFlowResolver";

/** Resolves new-patient flows through the single-medical-step experiment when the session flow name matches the control family. */
class SingleMedicalStepNewPatientFlowResolver extends BaseExperimentalFlowResolver {
  constructor(experimentActiveFlow: IFlow, experimentInactiveFlow: IFlow) {
    super(experimentActiveFlow, experimentInactiveFlow, ExperimentKey.SingleMedicalStepFlow);
  }
}

export default SingleMedicalStepNewPatientFlowResolver;
